/**
 * Removes the legacy drafting instruction wrapper from persisted user text.
 *
 * WHY this lives in `utils`: old conversations can still contain this internal
 * prefix, while both the visible message bubble and the Word export must show
 * only the attorney's question. Keeping one pure helper prevents those two
 * projections from drifting and avoids importing a component into DOCX code.
 */
export function stripRedactionPrefix(content: string): string {
  const re = /^\[INSTRUCTION_RÉDACTION\][\s\S]*?\[\/INSTRUCTION_RÉDACTION\]\s*/;
  return content.replace(re, '');
}
